import type Theme from "@onestore/hel/dist/typings/theme"

// Ported from `@onestore/hel/dist/utils/getCustomColor/index.js`.
type ColorFromPicker = string | { start: string; end: string }

// Ported from `@onestore/hel/dist/utils/getCustomColor/index.js`.
export function getCustomColor(
  customColor: ColorFromPicker | undefined,
  opacity?: number
): string | null {
  if (!customColor) {
    return null
  }

  if (typeof customColor === "string") {
    if (!opacity) {
      return customColor
    }

    const hex = customColor.replace(/[\s+#]/g, "")
    const normalizedHex = hex.length === 3 ? hex.replace(/(.)/g, "$1$1") : hex
    const alpha = Math.round(opacity * 255)
      .toString(16)
      .padStart(2, "0")

    return `#${normalizedHex}${alpha}`
  }

  return `linear-gradient(${customColor.start}, ${customColor.end})`
}

// Ported from `@onestore/hel/dist/utils/getCustomColor/index.js`.
export function getBackgroundByTextColor(
  textColor: Theme.CustomColor | undefined
): Theme.CustomColor | undefined {
  if (textColor === "customLight") {
    return "customDark"
  }

  if (textColor === "customDark") {
    return "customLight"
  }

  return undefined
}
